import { Paper } from '@mui/material';
import React, { useState } from 'react';
import { QueryParamControlUnitPage } from '../../CUPage.model';
import { ParameterEdit } from './ParameterEdit';
import { ParameterView } from './ParameterView';
import { getPolyglot } from '../../../../../../i18n';
import { ComposedParametersValue } from '../../../../../../redux/CUParameters/selectors';
import { useAppDispatch } from '../../../../../../redux/store.model';
import { setCUParameters } from '../../../../../../redux/CUParameters/action/thunks';
import {
  useShowErrorMessage,
  useShowMessage,
} from '../../../../../../util/hooks';

export interface ParameterProps extends QueryParamControlUnitPage {
  parameter: ComposedParametersValue;
}

function Parameter(props: ParameterProps) {
  const { deviceId = '', controlUnitId = '' } = props;
  const [showEdit, setShowEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const onClickOpenEdit = () => setShowEdit(true);
  const onClickCloseEdit = () => setShowEdit(false);
  const dispatch = useAppDispatch();
  const showMessage = useShowMessage();
  const showErrorMessage = useShowErrorMessage();
  const polyglot = getPolyglot();
  const onSave = (parameter: ComposedParametersValue, newValue: string) => {
    setLoading(true);
    dispatch(
      setCUParameters({
        deviceId,
        controlUnitId,
        parameterLevelName: parameter.level,
        parameter: parameter,
        parameterValue: newValue,
      })
    )
      .unwrap()
      .then(() => {
        showMessage(polyglot.t('device.parameters.save_value_successfully'));
        onClickCloseEdit();
      })
      .catch((error) => {
        error.message.startsWith('POLLING_')
          ? showErrorMessage('device.controlUnit.action.error.pooling', {
              variant: 'warning',
            })
          : showErrorMessage(error);
      })
      .finally(() => setLoading(false));
  };
  return showEdit ? (
    <ParameterEdit
      {...props}
      loading={loading}
      onClickClose={onClickCloseEdit}
      onSave={onSave}
    />
  ) : (
    <ParameterView {...props} onClickEdit={onClickOpenEdit} />
  );
}

export default Parameter;
